import React from "react";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
const BestPartner = (param) => {
  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }
  return (
    <React.Fragment>
      <Col xl={4}>
        <Card className="card-animate">
          <CardHeader className="align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1">Partner Terbaik</h4>
            <div className="flex-shrink-0">
              
            </div>
          </CardHeader>
          <CardBody>
            <div className="table-responsive table-card" style={{ height: "218px", overflow: "scroll" }}>
              <table className="table table-hover table-centered align-middle table-nowrap mb-0">
                <tbody>
                  {((param.data && param.data["best_agency"]) || []).map((item, key) => (
                    <tr key={key}>
                      <td>
                        <div className="d-flex align-items-center">
                          <div className="avatar-sm rounded p-1 me-2">
                            <div className="avatar-title rounded-circle bg-success text-white">
                              {item.name.charAt(0).toUpperCase()}
                            </div>
                          </div>
                          <div>
                            <h5 className="fs-14 my-1">
                              {item.name}
                            </h5>
                            <span className="text-info">{item.qtyOrders} </span>transaksi
                          </div>
                        </div>
                      </td>
                      <td>
                        <h5 className="fs-14 my-1 text-info">{currencyFormat(item.totalOrders)}</h5>
                        <span className="text-muted">Nilai Transaksi Penjualan</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default BestPartner;
